import React from 'react';
import ctrl from 'controllers/cotacao-ctrl';
import utils from 'utils/utils';
import Row from 'components/row';
import Col from 'components/col';
import Icon from 'components/icon';
import Detalhe from './cotacao-det-item';
import Dialog from 'components/dialog';
import Button from 'components/button';
import modal from 'utils/modal-service';
import {FormattedNumber} from 'react-intl';
import AvisoNotaFornecedor from './aviso-nota-fornecedor';
import sysCtrl from 'controllers/sys-ctrl';
import _ from 'lodash';
import ReactDOM from 'react-dom';
import toastService from 'utils/toast-service';

module.exports = React.createClass({

  getInitialState(){
    return {
      prazoEdit: -1
    }
  },

  componentDidUpdate(){
    if (this.state.prazoEdit != -1) {
      var node = ReactDOM.findDOMNode(this.refs.editPreco);
      if (node) node.focus();
    }
  },

  handleEditClick(item){
    var self = this;
    ctrl.selectItem(item);
    this.refs.detalheModal.show();
    setTimeout(() => {
      self.refs.detalhe.refs.editPreco.focus();
    }, 300);
  },

  handleSaveItem(){
    var self = this;
    ctrl.saveItemFornec().success(function(){
      self.refs.detalheModal.hide();
      setTimeout(ctrl.selectItem,500);
    });
  },

  handleDelItem(item){
    var self = this;

    modal.show(() => {
      ctrl.delItemFornec(item);
    },'Excluir preço da cotação','Confirma exclusão do preço do item "'+item.descricao+'"?',"danger");

  },

  renderCabPrecos(){
    return sysCtrl.data.condicoesPreco.map(function(prazo,index){
      return <th key={index} className="text-right" style={{width: 100}}>$ {prazo} dias </th>
    });
  },

  startEditPreco(item,prazo,precoAtual){
    this.setState({prazoEdit: prazo, itemEdit: item, precoEdit: precoAtual});
  },

  handleChangePreco(ev){
    this.setState({precoEdit: ev.target.value});
  },

  cancelEditing(){
    this.setState({prazoEdit: undefined, itemEdit: undefined, precoEdit: undefined});
  },

  saveEditPreco(){

    var self = this;
    var preco = utils.toNumber(self.state.precoEdit);

    if (isNaN(preco)) {
      if (self.state.precoEdit) toastService.toast('Valor informado não é um número válido.','danger');
      self.cancelEditing();
      return;
    }

    var payload = {
      idItem: self.state.itemEdit.id,
      idFornecedor: ctrl.data.fornecedor,
      preco: self.state.precoEdit,
      prazo: self.state.prazoEdit
    };

    ctrl.savePrecoItemFornec(payload).success(function(){
      self.cancelEditing();
    });

  },

  editKeyDown(ev){
    if (ev.keyCode == 13) {
      if (!this.state.precoEdit) toastService.toast('Se deseja apagar o valor, utilize o botão excluir.');
      this.saveEditPreco();
    }
  },

  renderPrecosItem(item, itemFor){
    var self = this;
    return sysCtrl.data.condicoesPreco.map(function(prazo,index){
      var content = '';
      var handleClick;
      var precoValor;

      if (self.state.prazoEdit == prazo && self.state.itemEdit == item) {
        content =
          <input ref="editPreco"
                 type="text"
                 value={self.state.precoEdit}
                 onChange={self.handleChangePreco}
                 onBlur={self.saveEditPreco}
                 onKeyDown={self.editKeyDown}
                 className="inline-edit" />
      } else {
        if (itemFor) {
          var preco = _.find(itemFor.precos, p => p.prazo == prazo);
          if (preco) {
            precoValor = preco.preco;
            content = <FormattedNumber value={preco.preco} minimumFractionDigits={2} />;
          }
        }
        handleClick = self.startEditPreco.bind(self,item,prazo,precoValor);
      }
      return <td key={index} className="text-right" style={{width: 100}} onClick={handleClick}>{content}</td>
    });
  },

  render(){

    var items = [];
    var self = this;

    ctrl.getItemOfPage().map(function(item,index){

      if (!item) return;

      var className = "item-cotacao";
      var isDelDisabled = true;
      var itemFor = ctrl.findItemFor(item);
      var precoInformado = '';

      if (itemFor) {
        className += ' item-fornecido';
        isDelDisabled = false;
      }

      items.push(
        <tr className={className} key={index}>
          <td>{item.codigo}</td>
          <td>{item.descricao}</td>
          <td>{item.marca}</td>
          <td className="text-right">{item.qtCompra}</td>
          <td className="text-center">{item.unidade}</td>
          <td className="text-center">{item.embalagem}</td>
          {self.renderPrecosItem(item,itemFor)}
          <td className="text-center"><div>
            <Button className="btn-sm" icon="trash" onClick={self.handleDelItem.bind(self,item)} disabled={isDelDisabled} />
            <Button style={{marginLeft: 5}}className="btn-sm" icon="pencil" onClick={self.handleEditClick.bind(self,item)} />
          </div></td>
        </tr>
      );

    });

    //preenche os restante com itens vazios
    while (items.length < ctrl.data.itemsPerPage) {
      items.push(<tr key={items.length}>
        <td className="text-center">&nbsp;</td>
        <td className="text-center">&nbsp;</td>
        <td className="text-center">&nbsp;</td>
        <td className="text-center">&nbsp;</td>
        <td className="text-center">&nbsp;</td>
        <td className="text-center">&nbsp;</td>
        <td className="text-center">&nbsp;</td>
        {sysCtrl.data.condicoesPreco.map( (o,i) => <td key={i} className="text-center">&nbsp;</td> )}
      </tr>);
    }

    var detalheModal, detButtons = [];

    if (ctrl.data.selectedItem) {
      detalheModal = <Detalhe ref="detalhe" item={ctrl.data.selectedItem} />
    }

    detButtons.push(<Button className="primary" key={2} onClick={this.handleSaveItem}>Salvar</Button>);

    var content;

    if (ctrl.data.fornecedor == undefined || ctrl.data.fornecedor == -1) {
      content = (<div className="well"><span className="erro">Por favor, selecione um fornecedor.</span></div>);
    } else if (ctrl.dadosFornec.notaFornecedor <= 5) {
      content = <AvisoNotaFornecedor />;
    } else {
      content = (
        <div className="panel panel-primary">
          <div className="panel-heading">
            <div className="container-fluid panel-container">
              <div className="col-xs-3 text-left">
                <h4 className="panel-title abc">
                  Itens em cotação
                </h4>
              </div>
              <div className="col-xs-9 text-right">
                <ul className="pagination panel-pagination">
                  <li><button className='btn btn-default' disabled={ctrl.isFirstPage()} onClick={ctrl.goFirstPage}><Icon name="fast-backward"/></button></li>
                  <li><button className='btn btn-default' disabled={ctrl.isFirstPage()} onClick={ctrl.goPriorPage}><Icon name="backward"/></button></li>
                  <li><button className='btn btn-default'>{ctrl.getCurPageLabel()}</button></li>
                  <li><button className='btn btn-default' disabled={ctrl.isLastPage()} onClick={ctrl.goNextPage}><Icon name="forward"/></button></li>
                  <li><button className='btn btn-default' disabled={ctrl.isLastPage()} onClick={ctrl.goLastPage}><Icon name="fast-forward"/></button></li>
                </ul>
              </div>
            </div>
          </div>

          <div className="table-responsive">
            <table className='table table-bordered table-hover'>
              <thead>
              <tr>
                <th>Código</th>
                <th>Descrição</th>
                <th>Marca</th>
                <th className="text-right">Qt.Cpr.</th>
                <th className="text-center">Unid.</th>
                <th className="text-center">Emb.</th>
                {this.renderCabPrecos()}
                <th className="text-center" style={{minWidth: 100}}>Ações</th>
              </tr>
              </thead>
              <tbody>
              {items}
              </tbody>
            </table>
          </div>
      </div>
      );
    }

    return (
      <div>

        <Dialog ref="detalheModal" large={true} otherButtons={detButtons} title="Informar preço do item">
          {detalheModal}
        </Dialog>

        {content}
      </div>
    )
  }

});


/** WEBPACK FOOTER **
 ** ./src/views/cotacao/cotacao-itens.js
 **/